import type { FC } from "react";
import { useState } from "react";
import { uniqueId } from "lodash";

import DialogCustom from "@/components/modals/dialog-custom";
import PatchConsultationModal from "@/components/modals/patch-consultation-modal";
import { Button } from "@/components/ui/button";
import DiseaseLabel from "@/components/ui/disease-label";
import { Separator } from "@/components/ui/separator";
import type { Consultation } from "@/types/api/consultation";
import { getConsultationStepLabel } from "@/types/api/consultation";
import { formatFullDate } from "@/utils/patient";
import { getConsultationFields } from "@/utils/treatment";

import ExtraField from "./extra-field";

type ConsultationSideModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  consultation?: Consultation;
  patientId: number;
};

const ConsultationSideModal: FC<ConsultationSideModalProps> = ({
  open,
  onOpenChange,
  consultation,
  patientId,
}) => {
  const [isPatchModalOpen, setIsPatchModalOpen] = useState(false);

  if (!consultation) return;

  const extraFields = getConsultationFields(consultation);

  return (
    <>
      <DialogCustom
        title="Consultation"
        description={
          <div className="text-sm text-gray-600">
            {formatFullDate(new Date(consultation.startDate))}
          </div>
        }
        open={open}
        onOpenChange={onOpenChange}
        side
      >
        <Separator />
        <div className="flex flex-1 flex-col gap-5 p-8 bg-grey-25">
          <div className="flex flex-col">
            <div className="text-xs text-gray-500">Motif</div>
            <DiseaseLabel
              customLabel={getConsultationStepLabel(
                consultation.consultationStep
              )}
              className="w-fit font-medium text-xs"
            />
          </div>
          <div>
            <div className="text-xs text-gray-500">Commentaire</div>
            <div className="text-sm break-words">{consultation.comment}</div>
          </div>
          {extraFields.map((extraField) => (
            <ExtraField
              key={`extra-fields-${consultation.id}-${uniqueId()}`}
              hidden={extraField.hidden}
              fields={extraField.fields}
            />
          ))}
        </div>
        <Separator />
        <div className="pt-6 px-6">
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={() => setIsPatchModalOpen(true)}
          >
            Modifier
          </Button>
        </div>
      </DialogCustom>
      <PatchConsultationModal
        open={isPatchModalOpen}
        setOpen={setIsPatchModalOpen}
        consultation={consultation}
        patientId={patientId}
      />
    </>
  );
};

export default ConsultationSideModal;
